import {
  faCircleCheck as freeFasFaCircleCheck,
  faArrowRight as freeFasFaArrowRight,
  faArrowDown as freeFasFaArrowDown,
  faPause as freeFasFaPause,
  faSearch as freeFasFaSearch,
  faShareNodes as freeFasFaShareNodes,
  faCirclePlay as freeFasFaCirclePlay,
  faTableCellsLarge as freeFasFaTableCellsLarge,
  faMinus as freeFasFaMinus,
  faPlus as freeFasFaPlus,
  faPlay as freeFasFaPlay,
  faLock as freeFasFaLock,
  faDownload as freeFasFaDownload,
  faUser as freeFasFaUser,
  faBars as freeFasFaBars,
  faThumbsUp as freeFasFaThumbsUp,
  faUpDownLeftRight as freeFasFaUpDownLeftRight,
  faTrash as freeFasFaTrash,
  faAngleLeft as freeFasFaAngleLeft,
  faAngleRight as freeFasFaAngleRight,
  faClipboard as freeFasFaClipboard,
  faXmark as freeFasFaXmark,
  faCheck as freeFasFaCheck,
  faHeart as freeFasFaHeart,
  faCloudArrowDown as freeFasFaCloudArrowDown
} from '@fortawesome/free-solid-svg-icons'

import {
  faFolder as freeFarFaFolder,
  faCommentDots as freeFarFaCommentDots,
  faClock as freeFarFaClock,
  faBookmark as freeFarFaBookmark,
  faCopy as freeFarFaCopy
} from '@fortawesome/free-regular-svg-icons'

export default {freeFasFaCircleCheck, freeFasFaArrowRight, freeFasFaArrowDown, freeFasFaPause, freeFasFaSearch, freeFasFaShareNodes, freeFasFaCirclePlay, freeFasFaTableCellsLarge, freeFasFaMinus, freeFasFaPlus, freeFasFaPlay, freeFasFaLock, freeFasFaDownload, freeFasFaUser, freeFasFaBars, freeFasFaThumbsUp, freeFasFaUpDownLeftRight, freeFasFaTrash, freeFasFaAngleLeft, freeFasFaAngleRight, freeFasFaClipboard, freeFasFaXmark, freeFasFaCheck, freeFasFaHeart, freeFasFaCloudArrowDown, freeFarFaFolder, freeFarFaCommentDots, freeFarFaClock, freeFarFaBookmark, freeFarFaCopy}